/* OK BYE — Fiche produit : barre d'achat dynamique + carrousel « Rencontre » */
(function () {
  if (window.__okbyeProductInit) return;
  window.__okbyeProductInit = true;

  function cssEscape(value) {
    return window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/["\\]/g, '\\$&');
  }

  /* ---------- Barre d'achat ---------- */
  function initBuybar(bar) {
    if (bar.__okbyeInit) return;
    bar.__okbyeInit = true;

    var sectionId = bar.dataset.section;
    var form = document.getElementById('product-form-' + sectionId);
    var mainButton = form ? form.querySelector('[name="add"]') : null;
    var watchTarget = form ? form.closest('.okbye-buy') || form : null;
    var buy = bar.querySelector('[data-okbye-buybar-buy]');
    if (!mainButton || !buy || !watchTarget) return;

    // Le bouton de la barre reflète toujours le vrai bouton (texte, prix, Épuisé)
    function syncButton() {
      buy.innerHTML = mainButton.innerHTML;
      buy.disabled = mainButton.hasAttribute('disabled');
    }
    syncButton();
    new MutationObserver(syncButton).observe(mainButton, {
      childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled']
    });

    buy.addEventListener('click', function () {
      if (!mainButton.hasAttribute('disabled')) mainButton.click();
    });

    // Pilules ↔ vrai sélecteur de variantes
    var picker = document.querySelector('variant-radios[data-section="' + sectionId + '"], variant-selects[data-section="' + sectionId + '"]');

    function syncPills() {
      if (!picker) return;
      bar.querySelectorAll('.okbye-buybar__option').forEach(function (group) {
        var current = null;
        var fieldset = picker.querySelector('[data-option-index="' + group.dataset.optionIndex + '"]');
        if (fieldset) {
          var checked = fieldset.querySelector('input:checked');
          if (checked) current = checked.value;
        }
        if (current === null) {
          var select = picker.querySelector('select[name="options[' + group.dataset.optionName + ']"]');
          if (select) current = select.value;
        }
        group.querySelectorAll('.okbye-buybar__pill').forEach(function (pill) {
          pill.classList.toggle('is-active', pill.dataset.value === current);
        });
      });
    }

    bar.addEventListener('click', function (e) {
      var pill = e.target.closest('.okbye-buybar__pill');
      if (!pill || !picker) return;
      var group = pill.closest('.okbye-buybar__option');
      var fieldset = picker.querySelector('[data-option-index="' + group.dataset.optionIndex + '"]');
      var input = fieldset ? fieldset.querySelector('input[value="' + cssEscape(pill.dataset.value) + '"]') : null;
      if (input) {
        input.click();
      } else {
        var select = picker.querySelector('select[name="options[' + group.dataset.optionName + ']"]');
        if (select) {
          select.value = pill.dataset.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      setTimeout(syncPills, 30);
    });

    if (picker) picker.addEventListener('change', function () { setTimeout(syncPills, 30); });

    // Visible dès que le bouton principal est sorti de l'écran (par le haut)
    function setVisible(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = visible ? 0 : -1; });
      document.body.classList.toggle('okbye-buybar-open', visible);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(watchTarget);
    }
  }

  /* ---------- Carrousel « Rencontre » : flèches ---------- */
  function initCarousel(root) {
    if (root.__okbyeInit) return;
    root.__okbyeInit = true;
    var track = root.querySelector('[data-okbye-track]');
    var prev = root.querySelector('[data-okbye-prev]');
    var next = root.querySelector('[data-okbye-next]');
    if (!track) return;

    function step() { return Math.max(track.clientWidth * 0.8, 200); }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.hidden = track.scrollLeft <= 2;
      if (next) next.hidden = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 400);
  }

  function init() {
    document.querySelectorAll('[data-okbye-buybar]').forEach(initBuybar);
    document.querySelectorAll('[data-okbye-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
